const COMPONENT_NAME = "ModalCloseButton";
export {
  COMPONENT_NAME
};
